/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_LabelInputs */

const vi_carrier_legacy_label = /** @type {(inputs: Carrier_Legacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phường/xã cũ in trên tem VTP`)
};

/**

* @param {Carrier_Legacy_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_label = /** @type {((inputs?: Carrier_Legacy_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_label(inputs)
});